import QueryBuilder from "../QueryBuilder"

export default class InPageBannerSimpleRepository {
    constructor(public contentName: string) {}

    async fetch() {
        const results = await new QueryBuilder()
            .buildQuery(this.contentName, [
                "bannerText",
                "subheaderText",
                "banner_label",
                "text_highlight",
            ])
            .process()

        return results.getResultInfo()
    }
}
